(function () {
    "use strict";
    angular.module("app").component("requestHeader", {
        templateUrl: "@/detailHeader/request-header.template.html",
        transclude: {
            "subject": "requestName",
            "type": "requestType",
            "dossier": "requestDossier",
        },
        bindings: {
            organisation: "<",
            request: "<",
            organisationUrl: "@",
            dossierUrl: "@",
        },
        controller: function () { }
    });
})();